import useGet from "api/useGet";
import * as fatchSet from "../../api/api";
import React, {useEffect, useRef, useState} from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ContentsSection, EditerBox, PageTitle } from "component/app/items";
import { Footer } from "component/elements/footer";
import { Header } from "component/elements/header";
import { CustomPopup, LoadingBox } from "component/basic/popup";
import { BtnBox, BtnItem } from "component/basic/btns";
import { TextAreaItem } from "component/basic/formItems";
import { carCode, comFormat, feeText, PhoneSetting, setDateTime } from "js/function";
import { CarDetailItem } from "component/product/car";
import { RentPopupContents } from "pages/popup/Popup";
import { DotText, FixedPage, FixedSection } from "component/basic";
import { AnnouncementPopupSection, CaptionBox, CarCouponSection, CarDetailAnnouncementBox, CarDetailAnnouncementTextBox, CarDetailControllBasicText, CarDetailControllBox,CarDetailControllBoxTitleBox, CarDetailOptionTypeBox, CarDetailSection, CarDetailSectionSubTitle, CarDetailTextArea, CarDetailTextAreaTitle, CarDetailTextBox, CouponPackItem, CouponPackItemBox, FixedContents, PaymentSuccessTextBox, PopupCaptionDotTextBox, ReviewStarSelBox } from "component/product/page";

const ReservationDetail = (props) => {
    const navigate = useNavigate();
    const param = useParams();
    const id = param.id;

    const location = useLocation();
    const locationData = location?.state ? location?.state : null;
    const pageType = locationData?.pageType;
    const memberCode = locationData?.memberCode;
    const sendWcs = locationData?.sendWcs;

    const [loadingBoxOpen,setLoadingBoxOpen] =  useState(true);

    const pageDataApi = useGet({
        url:`/reservation/detail?reservation_id=${id}${localStorage.getItem("token") ? "" : `&code=${memberCode?.code}&phone=${memberCode?.phone}`}`,
        loginType:"login"
    });
    const pageData = pageDataApi?.data?.reservation;
    const add_products = pageData?.add_products;

    const shuttleApi = useGet({
        url:`/shuttle`,
        loginType:"login"
    });
    const shuttleData = shuttleApi?.data;

    const [reviewPopup,setReviewPopup] =  useState(null);
    const [reviewContents,setReviewContents] =  useState({
        star:0,
        text:""
    });
    const [btnChk,setBtnChk] =  useState(true);
    const [submitChk,setSubmitChk] =  useState(true);

    const [serviceCancelPopup,setServiceCancelPopup] =  useState(null);
    const [reservationCancelPopup,setReservationCancelPopup] =  useState(null);

    const cancelFeeApi = useGet({
        url:`/reservation/cancel/fee`,
        loginType:"login"
    });
    const cancelFeeData = cancelFeeApi?.data?.cancel_fee_settings;
    
    const couponApi = useGet({
        url:id && localStorage.getItem("token") ? `/reservation/company/coupon?reservation_id=${id}` : null,
        loginType:"login"
    });
    const couponData = couponApi?.data?.user_company_coupons;
    const couponCountData = couponApi?.data?.company_count;

    const [couponPopup,setCouponPopup] =  useState(null);

    const cancelPriceApi = useGet({
        url:id && (localStorage.getItem("token") ? true : memberCode ? true : false) && (pageType !== "payment" && pageType !== "paymentEdit") ? `/reservation/cancel/check?reservation_id=${id}${localStorage.getItem("token") ? "" : `&code=${memberCode?.code}&phone=${memberCode?.phone}`}` : null,
        loginType:"login"
    });
    const cancel_price = cancelPriceApi?.data?.cancel_price;
    const cancel_percent = cancelPriceApi?.data?.cancel_percent;

    function reviewDataCh(key,val){
        let oldData = {...reviewContents};
        oldData[key] = val;
        setReviewContents(oldData);
    }

    function reviewAdd(){
        if(submitChk){
            setSubmitChk(false);
            window.loadingBox(true);

            let formData = new FormData();
            formData.append("reservation_id", id);
            formData.append("grade", reviewContents?.star);
            formData.append("review", reviewContents?.text);

            fatchSet.FatchApi({
                type:"POST",
                formDataItem: formData,
                loginType: "login",
                url: `/review/register`,
                success: (apiData) => {
                    setSubmitChk(true);
                    window.loadingBox(false);
                    setBtnChk(true);

                    window.errPopupOpen({
                        alert:"리뷰 작성 완료",
                        data:`리뷰 작성이 완료되었습니다!<br/>${apiData?.data?.reward ? `${apiData?.data?.reward}<br/>지급 완료되었습니다.` : ""}`,
                        closeType:true,
                        func:()=>{
                            setReviewPopup(null);
                        }
                    });
                },
                err: (apiData) => {
                    setSubmitChk(true);
                    if(apiData?.data || apiData?.alert){
                        window.errPopupOpen(apiData);
                    }
                    window.loadingBox(false);
                }
            })
        }
    }

    function serviceCancelFunc(){
        if(submitChk){
            setSubmitChk(false);
            window.loadingBox(true);

            let formData = new FormData();
            formData.append("reservation_id", id);

            fatchSet.FatchApi({
                type:"POST",
                formDataItem: formData,
                loginType: "login",
                url: `/reservation/service/cancel`,
                success: (apiData) => {
                    setSubmitChk(true);
                    window.loadingBox(false);
                    setBtnChk(true);

                    window.errPopupOpen({
                        alert:"부가서비스 취소",
                        data:`부가서비스 예약 취소가 완료되었습니다.<br/>환불 금액은 결제수단에 따라 최대 3~7영업일 소요됩니다.`,
                        closeType:false,
                        func:()=>{
                            setServiceCancelPopup(null);
                            window.location.reload(true);
                        }
                    });
                },
                err: (apiData) => {
                    setSubmitChk(true);
                    if(apiData?.data || apiData?.alert){
                        window.errPopupOpen(apiData);
                    }
                    window.loadingBox(false);
                }
            })
        }
    }

    function reservationCancelFunc(){
        if(submitChk){
            setSubmitChk(false);
            window.loadingBox(true);

            let formData = new FormData();
            formData.append("reservation_id", id);
            formData.append("code", memberCode?.code);
            formData.append("phone", memberCode?.phone);

            fatchSet.FatchApi({
                type:"POST",
                formDataItem: formData,
                loginType: "login",
                url: `/reservation/cancel`,
                success: (apiData) => {
                    setSubmitChk(true);
                    window.loadingBox(false);
                    setBtnChk(true);

                    window.errPopupOpen({
                        alert:"예약 취소 완료",
                        data:`예약 취소가 완료되었습니다.<br/>환불 금액은 결제수단에 따라 최대 3~7영업일 소요됩니다.`,
                        closeType:false,
                        func:()=>{
                            setReservationCancelPopup(null);
                            window.location.reload(true);
                        }
                    });
                },
                err: (apiData) => {
                    setSubmitChk(true);
                    if(apiData?.data || apiData?.alert){
                        window.errPopupOpen(apiData);
                    }
                    window.loadingBox(false);
                }
            })
        }
    }

    useEffect(() => {
        if ((pageType === "payment" || pageType === "paymentEdit") && pageData) {
            if (sendWcs) {
                return false;
            }

            if (!window.wcs_add) window.wcs_add = {};
            window.wcs_add["wa"] = process.env.REACT_APP_NAVER_ANALYTIC_ID;
            if (window.wcs) {
                const _conv = {};
                _conv.type = 'purchase';
                _conv.value = pageData?.payment_price;
                _conv.id = pageData?.reservation_code;
                _conv.items = [{
                    id: pageData?.product_id,
                    name: pageData?.name,
                    payAmount: pageData?.original_price,
                }];

                window.wcs.trans(_conv);
            }

            navigate(`/reservation/detail/${id}`,{state: {sendWcs:true}});
        }
    }, [pageType, pageData]);

    useEffect(() => {
        if(pageData){
            setLoadingBoxOpen(false);
        }

        if(pageDataApi?.success === false){
            window.errPopupOpen({
                alert:"예약 조회 실패",
                data:`예약이 존재하지 않거나 접근 권한이 없습니다.</br>문제가 반복될 경우 고객센터 <span class='wbTextColor'>064-711-3200</span>로<br/>연락주시면 빠른 대응이 가능합니다.`,
                closeType:false,
                func:()=>{}
            });

            navigate("/");
        }
    }, [pageDataApi]);

    useEffect(() => {
        setTimeout(() => {
            setLoadingBoxOpen(false);
        }, 2000);
    }, []);

    useEffect(() => {
        if(reviewContents?.star >= 1 && reviewContents?.text !== "" && reviewContents?.text?.length >= 10){
            setBtnChk(false);
        }else{
            setBtnChk(true);
        }
    }, [reviewContents]);

    return (
        <>
            <ContentsSection
                header={true}
                footer={false}
                pcFooter={true}
                mBtn={true}
                addClass={"gBg"}
            >
                <Header
                    addClass=""
                    logo={false}
                    mMenu={false}
                    pageBack={true}
                    func={()=>{navigate(-1)}}
                    headTitle={"예약내역"}
                    rightBtnsArr={null}
                    pageClose={false}
                    activeType={1}
                    closeFunc={()=>{}}
                />
                <PageTitle
                    pageBack={()=>{navigate(-1)}}
                    contents="예약확인"
                />
                <FixedPage addClass="detailFixedPage">
                    <FixedContents addClass="">
                        <CarDetailItem
                            itemType=""
                            sectionCaptions={[
                                "차량 제원 및 옵션은 현장 사정에 따라 다른 옵션으로 구성된 차량이거나 동급차량으로 변경될 수 있습니다."
                            ]}
                            status={pageData?.status}
                            car_image={pageData?.image_url}
                            maker={pageData?.maker}
                            modelName={pageData?.name}
                            passengerNum={pageData?.passenger_number}
                            fuelType={pageData?.fuel}
                            min_year={pageData?.min_year}
                            max_year={pageData?.max_year}
                            car_option={pageData?.options}
                            carOptionDisable={pageData?.non_options}
                            func={()=>{}}

                            reservation_cancel_request={pageData?.reservation_cancel_request}
                        />
                        {couponData && couponData?.length > 0 ? 
                            <CarCouponSection
                                addClass=""
                                couponImg={couponData[0]?.company_image_url}
                                couponText={`AMANO 렌터카허브 고객만을 위한<br/>100개 이상의 가맹점 쿠폰팩 도착!`}
                                func={()=>{
                                    setCouponPopup({
                                        addClass:"",
                                        title:"쿠폰팩 발급 안내",
                                        subTitle:null,
                                        closeType:true,
                                        closeFunc:(e) => {setCouponPopup(null)}
                                    });
                                }}
                            />
                        :""}
                        <CarDetailSection title="대여조건 안내">
                            <CarDetailTextArea title={null} addClass="">
                                <CarDetailOptionTypeBox
                                    data={[
                                        {
                                            addClass:pageData?.is_pet == 0 ? "rColor" : "",
                                            icon:"rant_condition_0",
                                            name:"반려동물 동반",
                                            text:pageData?.is_pet == 0 ? "불가" : pageData?.is_pet == 1 ? "가능" : "-"
                                        },
                                        {
                                            addClass:pageData?.is_foreigner == 0 ? "rColor" : "",
                                            icon:"rant_condition_1",
                                            name:"외국인 대여",
                                            text:pageData?.is_foreigner == 0 ? "불가" : pageData?.is_foreigner == 1 ? "가능" : "-"
                                        },
                                        {
                                            addClass:pageData?.is_fishing == 0 ? "rColor" : "",
                                            icon:"rant_condition_2",
                                            name:"낚시용품 지참",
                                            text:pageData?.is_fishing == 0 ? "불가" : pageData?.is_fishing == 1 ? "가능" : "-"
                                        },
                                        {
                                            addClass:pageData?.is_smoke == 0 ? "rColor" : "",
                                            icon:"rant_condition_3",
                                            name:"금연 차량",
                                            text:pageData?.is_smoke == 0 ? "금연" : pageData?.is_smoke == 1 ? "흡연 가능" : "-"
                                        }
                                    ]}
                                />
                                <CarDetailTextBox
                                    addClass=""
                                    name={`운전자 연령`}
                                    text={`<span class='wbTextColor'>만 ${pageData?.min_age||"-"}세</span> 이상`}
                                />
                                <CarDetailTextBox
                                    addClass=""
                                    name={`면허 유형`}
                                    text={`<span class='wbTextColor'>${pageData?.license||"-"}</span> 이상`}
                                />
                                <CarDetailTextBox
                                    addClass=""
                                    name={`운전 경력`}
                                    text={`<span class='wbTextColor'>${pageData?.career||"-"}년</span> 이상`}
                                />
                            </CarDetailTextArea>
                        </CarDetailSection>
                        <CarDetailSection title="예약 정보">
                            <CarDetailTextArea title={null} addClass="">
                                <CarDetailTextBox
                                    addClass=""
                                    name={`렌터카 업체`}
                                    text={pageData?.company_name||"-"}
                                />
                            </CarDetailTextArea>
                            <CarDetailTextArea title={null} addClass="">
                                <CarDetailTextBox
                                    addClass=""
                                    name={`대여일시`}
                                    text={pageData?.start_date ? setDateTime(pageData?.start_date,"dayyyMinmmddhh",null) : "-"}
                                />
                                <CarDetailTextBox
                                    addClass=""
                                    name={`반납일시`}
                                    text={pageData?.end_date ? setDateTime(pageData?.end_date,"dayyyMinmmddhh",null) : "-"}
                                />
                            </CarDetailTextArea>
                            <CarDetailTextArea title={null} addClass="">
                                <CarDetailTextAreaTitle title={`예약자 정보 : ${pageData?.reservation_name||"-"}`}/>
                                <CarDetailTextBox
                                    addClass="minSize"
                                    name={`휴대폰 번호`}
                                    text={pageData?.reservation_phone ? PhoneSetting(pageData?.reservation_phone) : "-"}
                                />
                                <CarDetailTextBox
                                    addClass="minSize"
                                    name={`이메일`}
                                    text={pageData?.reservation_email||"-"}
                                />
                            </CarDetailTextArea>
                            <CarDetailTextArea title={null} addClass="">
                                <CarDetailTextAreaTitle title={`운전자 정보 : ${pageData?.driver_name||"-"}`}/>
                                <CarDetailTextBox
                                    addClass="minSize"
                                    name={`휴대폰 번호`}
                                    text={pageData?.driver_phone ? PhoneSetting(pageData?.driver_phone) : "-"}
                                />
                                <CarDetailTextBox
                                    addClass="minSize"
                                    name={`운전자 생년월일`}
                                    text={pageData?.driver_birth||"-"}
                                />
                                <CarDetailTextBox
                                    addClass="minSize"
                                    name={`운전경력`}
                                    text={pageData?.driver_career ? `${pageData?.driver_career||""}년</span> 이상` : "-"}
                                />
                                <CarDetailTextBox
                                    addClass="minSize"
                                    name={`면허종류`}
                                    text={pageData?.driver_license||"-"}
                                />
                            </CarDetailTextArea>
                        </CarDetailSection>
                        <CarDetailSection title="보험 정보">
                            <CarDetailAnnouncementBox
                                boxTitle={null}
                                title={`<span>${pageData?.insurance_name||"-"}</span><span class='line'>l</span><span class='sub'>만 ${pageData?.driving_age||"00"}세 이상 / 운전경력 ${pageData?.driving_experience||"00"}년 이상</span>`}
                                subTitle={`+ ${comFormat(pageData?.insurance_price||"0")} 원`}
                            >
                                <CarDetailAnnouncementTextBox
                                    name="보상한도"
                                    text={`${pageData?.insurance_limit||""} (${pageData?.insurance_limit ? "제한" : "무제한"})`}
                                />
                                <CarDetailAnnouncementTextBox
                                    name="면책금"
                                    text={`${pageData?.charge_immunity||""} (${pageData?.charge_immunity ? "발생" : "면제"})`}
                                />
                                <CarDetailAnnouncementTextBox
                                    name="휴차보상료"
                                    text={pageData?.rest_price||"-"}
                                />
                                <CarDetailAnnouncementTextBox
                                    name="단독사고 보장"
                                    text={pageData?.include_single_accident === 1 ? "보장" : "미보장"}
                                />
                                <CarDetailAnnouncementTextBox
                                    name="휠/타이어 파손 보장"
                                    text={pageData?.include_tire_damage === 1 ? "보장" : "미보장"}
                                />
                            </CarDetailAnnouncementBox>
                            <CarDetailAnnouncementBox
                                boxTitle={`${pageData?.company_name||"-"} 종합 보험 안내사항`}
                                title={pageData?.comprehensive_insurance_name||"-"}
                                subTitle=""
                            >
                                <CarDetailAnnouncementTextBox
                                    addClass="mCol"
                                    name="대인 보상범위"
                                    text={`${pageData?.person_insurance||""}${pageData?.person_insurance_etc ? ` (${pageData?.person_insurance_etc})` : ""}`}
                                />
                                <CarDetailAnnouncementTextBox
                                    addClass="mCol"
                                    name="대물 보상범위"
                                    text={`${pageData?.car_insurance||""}${pageData?.car_insurance_etc ? ` (${pageData?.car_insurance_etc})` : ""}`}
                                />
                                <CarDetailAnnouncementTextBox
                                    addClass="mCol"
                                    name="자손 보상범위"
                                    text={`${pageData?.self_insurance||""}${pageData?.self_insurance_etc ? ` (${pageData?.self_insurance_etc})` : ""}`}
                                />
                            </CarDetailAnnouncementBox>
                        </CarDetailSection>
                        <CarDetailSection title="결제 정보">
                            <CarDetailTextArea title={null} addClass="">
                                <CarDetailTextBox
                                    addClass=""
                                    name={`결제수단`}
                                    text={carCode("payment_method",pageData?.payment_method)}
                                />
                            </CarDetailTextArea>
                            <CarDetailTextArea title={null} addClass="">
                                <CarDetailTextBox
                                    addClass=""
                                    name={`차량 대여 및 보험 요금 (${pageData?.insurance_name})`}
                                    text={`${comFormat(pageData?.original_price)||"0"} 원`}
                                />
                                {pageData?.coupon_price || pageData?.use_point ? 
                                    <>
                                    <CarDetailTextAreaTitle title={"할인 적용"}/>
                                    {pageData?.coupon_price ? 
                                    <CarDetailTextBox
                                        addClass="minSize"
                                        name={`${pageData?.coupon_name||"-"}(${pageData?.discount_value ? "-" : ""}${comFormat(pageData?.discount_value||"0")}${pageData?.discount_type === "percent" ? "%" : "원"})`}
                                        text={`- ${comFormat(pageData?.coupon_price||"0")} 원`}
                                    />
                                    :""}
                                    {pageData?.use_point ? 
                                    <CarDetailTextBox
                                        addClass="minSize"
                                        name={"포인트 사용"}
                                        text={`- ${comFormat(pageData?.use_point||"0")} 원`}
                                    />
                                    :""}
                                    </>
                                :""}
                            </CarDetailTextArea>
                            <CarDetailTextArea title={null} addClass="">
                                <CarDetailTextBox
                                    addClass=""
                                    name="부가서비스"
                                    text={`${comFormat(pageData?.add_product_price||"0")} 원`}
                                />
                                {add_products && add_products?.map((item,i)=>(
                                    <CarDetailTextBox
                                        key={i}
                                        addClass="minSize"
                                        name={`${item.name} * ${item.amount}`}
                                        text={`${comFormat(item.price||"0")} 원`}
                                    />
                                ))}
                            </CarDetailTextArea>
                            {add_products && add_products?.length > 0 ? 
                            <>
                            <BtnItem
                                addClass="line gColor"
                                contents={"부가서비스 취소"}
                                func={() => {
                                    setServiceCancelPopup({
                                        addClass:"subTitle_line_2",
                                        title:"부가서비스 예약 취소",
                                        subTitle:"부가서비스 예약을 취소하시겠습니까?<br/>예약을 취소할 경우 취소 규정에 따라 환불이 진행됩니다.",
                                        closeType:true,
                                        closeFunc:(e) => {setServiceCancelPopup(null)}
                                    });
                                }}
                            />
                            </>
                            :""}
                            <CarDetailTextArea title={null} addClass="">
                                <CarDetailTextBox
                                    addClass="maxSize"
                                    name="총 결제 금액"
                                    text={`${comFormat(pageData?.payment_price||"0")} 원<br/><span>${comFormat(pageData?.add_point||"0")} 포인트 적립</span>`}
                                />
                            </CarDetailTextArea>
                        </CarDetailSection>
                        <CarDetailSection title="안내사항">
                            <CarDetailSectionSubTitle title="차량 출고/반납지 안내"/>
                            <RentPopupContents
                                func={(addrData)=>{}}
                            />
                            <CarDetailSectionSubTitle title="셔틀버스 이용 안내"/>
                            <EditerBox addClass="" data={shuttleData?.contents}/>
                        </CarDetailSection>
                    </FixedContents>
                    <FixedSection
                        pageBox="pageSizing"
                        boxAddClass=""
                        addClass="nonFixed mNonMb"
                        contentsBox="fixedPage"
                        nonFixed={true}
                        headerChk={true}
                        footerChk={true}
                        minSize={961}
                    >
                        {pageType && (pageType === "payment" || pageType === "paymentEdit") ? 
                        <CarDetailControllBox
                            addClass="notTitle nonFixed"
                            title={null}
                            subTitle={null}
                        >
                            <PaymentSuccessTextBox
                                title={pageType === "paymentEdit" ? "예약 변경 완료" : "예약 및 결제 완료"}
                                text={pageType === "paymentEdit" ? "정상적으로 예약 변경이 완료되었습니다.<br/>아래 예약내용을 확인해주세요." : "정상적으로 예약 및 결제가 완료되었습니다.<br/>아래 예약내용을 확인해주세요."}
                                type={pageType}
                            />
                            <CarDetailControllBoxTitleBox
                                title={"예약번호"}
                                subTitle={pageData?.reservation_code}
                            />
                            <BtnBox
                                boxType=""
                                addClass={`mFixed ${localStorage.getItem("token") ? "col2" : ""}`}
                            >
                                <BtnItem
                                    addClass="dbColor"
                                    contents="홈으로"
                                    func={() => {
                                        navigate("/")
                                    }}
                                />
                                {localStorage.getItem("token") ? 
                                    <BtnItem
                                        addClass=""
                                        contents={"예약확인"}
                                        func={() => {
                                            navigate(`/reservation`)
                                        }}
                                    />
                                :""}
                            </BtnBox>
                        </CarDetailControllBox>
                        :
                        <CarDetailControllBox
                            addClass="nonFixed"
                            title={"예약번호"}
                            subTitle={pageData?.reservation_code}
                        >
                            {cancel_percent !== null ? 
                            <>
                            <CarDetailControllBasicText
                                text={
                                    pageData?.reservation_cancel_request === 1 ? "예약 취소 승인 진행중입니다."
                                    : pageData?.status === 10 ? `예약이 취소되었습니다.<br/>예약 관련 문의사항은 고객센터 <span class='wbTextColor'>064-711-3200</span>로<br/>연락주시면 빠른 대응이 가능합니다.`
                                    : pageData?.status === 2 ? `즐거운 여행 되셨나요?<br/>차량 이용 리뷰를 남겨주시면 모든 고객분들에게<br/><span class='wbTextColor'>${pageDataApi?.data?.review_reward}</span> 지급!`
                                    : pageData?.status === 1 ? `즐거운 여행 중이신가요?<br/>차량에 문제가 생기셨다면 고객센터 <span class='wbTextColor'>064-711-3200</span>로<br/>연락주시면 빠른 대응이 가능합니다.`
                                    : pageData?.status === 0 ? 
                                    cancel_percent >= 100 ? `곧 여행이 시작됩니다.<br/>A 렌터카 허브과 즐거운 여행되세요!`
                                        : cancel_percent == 0 && cancelFeeData && feeText(cancelFeeData) ? `<span class='wbTextColor'>${feeText(cancelFeeData)}</span>까지<br/>예약된 차량/일정/보험/부가서비스 변경이 가능합니다.`
                                        : cancel_percent >= 0 ? `예약된 차량/일정/보험/부가서비스 변경 가능,<br/>예약 변경 시 <span class='wbTextColor'>${cancel_percent||0}</span>% 의 수수료가 발생합니다.`
                                        : ""
                                    : ""
                                }
                            />
                            <BtnBox
                                boxType=""
                                addClass={pageData?.status === 0 && cancel_percent < 100 && pageData?.reservation_cancel_request !== 1 ? "mFixed col2" : "mFixed"}
                            >
                                {pageData?.status === 0 && pageData?.reservation_cancel_request !== 1 ? 
                                    <BtnItem
                                        addClass="dbColor"
                                        contents="예약 취소"
                                        func={() => {
                                            setReservationCancelPopup({
                                                addClass:"subTitle_line_2",
                                                title:"예약 취소",
                                                subTitle:"예약을 취소하시겠습니까?<br/>예약을 취소할 경우 취소 규정에 따라 환불이 진행됩니다.",
                                                closeType:true,
                                                closeFunc:(e) => {setReservationCancelPopup(null)}
                                            });
                                        }}
                                    />
                                :""}
                                {(pageData?.status === 0 && cancel_percent < 100) || pageData?.status === 1 || pageData?.status === 2 || pageData?.status === 10 || pageData?.reservation_cancel_request === 1 ?
                                    <BtnItem
                                        addClass=""
                                        contents={pageData?.status === 2 ? "리뷰 작성" : pageData?.status === 1 || pageData?.status === 10 || pageData?.reservation_cancel_request === 1 ? "고객센터 문의" : "예약 변경"}
                                        func={() => {
                                            if(pageData?.status === 0 && cancel_percent < 100 && pageData?.reservation_cancel_request !== 1){
                                                navigate(`/reservation/edit/${id}`,{state: {memberCode:memberCode}});
                                            }
                                            if(pageData?.status === 2){
                                                if(pageData?.is_review === 1){
                                                    window.errPopupOpen({
                                                        alert:"리뷰 작성 불가",
                                                        data:`이미 리뷰를 작성하셨습니다.`,
                                                        closeType:true,
                                                        func:()=>{}
                                                    });
                                                }else{
                                                    setReviewPopup({
                                                        addClass:"",
                                                        title:"리뷰 작성",
                                                        subTitle:null,
                                                        closeType:true,
                                                        closeFunc:(e) => {setReviewPopup(null)},
                                                        closePcOn:true
                                                    });
                                                }
                                            }
                                            if(pageData?.status === 1 || pageData?.status === 10 || pageData?.reservation_cancel_request === 1){
                                                navigate("/faq");
                                            }
                                        }}
                                    />
                                :""}
                            </BtnBox>
                            </>
                            :""}
                        </CarDetailControllBox>
                        }
                    </FixedSection>
                </FixedPage>
            </ContentsSection>
            <CustomPopup data={reviewPopup} basicPB={false} mSize={true}>
                <ReviewStarSelBox
                    val={reviewContents?.star}
                    func={(val)=>{reviewDataCh("star",val)}}
                />
                <TextAreaItem
                    addClass=""
                    inputName="리뷰 내용"
                    placeholder="(최소 10자 이상) 리뷰 내용을 최대한 자세히 입력해주세요.&#13;&#10;관련되지 않는 내용을 입력하실 경우 등록 및 혜택 지급이 제한될 수 있습니다."
                    max={100}
                    maxChk={false}
                    value={reviewContents?.text}
                    func={(value)=>reviewDataCh("text",value)}
                />
                <CaptionBox addClass="reviewCaptionBox">
                    <DotText text={"작성된 리뷰는 운영정책에 따라 예고 없이 삭제될 수 있습니다."}/>
                    <DotText text={"예약 또는 차량과 관련된 리뷰가 아닐 경우 지급된 혜택이 회수될 수 있습니다."}/>
                </CaptionBox>
                <BtnBox
                    boxType="fixed"
                    addClass=""
                >
                    <BtnItem
                        addClass=""
                        contents={"리뷰 작성"}
                        disabled={btnChk}
                        func={() => {reviewAdd()}}
                    />
                </BtnBox>
            </CustomPopup>
            <CustomPopup data={serviceCancelPopup} basicPB={false} mSize={false}>
                <CarDetailAnnouncementBox
                    boxTitle={null}
                    title={null}
                    subTitle={null}
                >
                    <CarDetailAnnouncementTextBox
                        name="부가서비스 결제 금액"
                        text={`${comFormat(pageData?.add_product_price||"0")} 원`} 
                    />
                    <CarDetailAnnouncementTextBox
                        name="환불 수수료"
                        text={`- ${comFormat(cancel_price||"0")} 원`} 
                    />
                    <CarDetailAnnouncementTextBox
                        addClass="bSize"
                        name="예상 환불 금액"
                        text={`${comFormat(String(Number(pageData?.add_product_price||0) - Number(cancel_price||0)))} 원`} 
                    />
                </CarDetailAnnouncementBox>
                <AnnouncementPopupSection data={cancelFeeData}/>
                <BtnBox
                    boxType="fixed"
                    addClass="col2"
                >
                    <BtnItem
                        addClass="subColor"
                        contents={"닫기"}
                        disabled={false}
                        func={() => {setServiceCancelPopup(null)}}
                    />
                    <BtnItem
                        addClass=""
                        contents={"부가서비스 취소"}
                        disabled={false}
                        func={() => {serviceCancelFunc()}}
                    />
                </BtnBox>
            </CustomPopup>
            <CustomPopup data={reservationCancelPopup} basicPB={false} mSize={false}>
                <CarDetailAnnouncementBox
                    boxTitle={null}
                    title={null}
                    subTitle={null}
                >
                    <CarDetailAnnouncementTextBox
                        name="총 결제 금액"
                        text={`${comFormat(pageData?.payment_price||"0")} 원`} 
                    />
                    <CarDetailAnnouncementTextBox
                        name="환불 수수료"
                        text={`- ${comFormat(cancel_price||"0")} 원`}
                    />
                    <CarDetailAnnouncementTextBox
                        addClass="bSize"
                        name="예상 환불 금액"
                        text={`${comFormat(String(Number(pageData?.payment_price||0) - Number(cancel_price||0)))} 원`} 
                    />
                </CarDetailAnnouncementBox>
                <AnnouncementPopupSection data={cancelFeeData}/>
                <BtnBox
                    boxType="fixed"
                    addClass="col2"
                >
                    <BtnItem
                        addClass="subColor"
                        contents={"닫기"}
                        disabled={false}
                        func={() => {setReservationCancelPopup(null)}}
                    />
                    <BtnItem
                        addClass=""
                        contents={"예약 취소"}
                        disabled={false}
                        func={() => {reservationCancelFunc()}}
                    />
                </BtnBox>
            </CustomPopup>
            <CustomPopup data={couponPopup} basicPB={false} mSize={true}>
                <CouponPackItemBox>
                    {couponData && couponData?.length > 0 && couponData?.map((item,i)=>(
                        <CouponPackItem
                            key={i}
                            name={item.company_name}
                            couponImg={item.company_image_url}
                        />
                    ))}   
                </CouponPackItemBox>
                {couponData ? 
                    <h1 className="couponPopup_captionText">{`${couponCountData > 4 ? "이 외 " : "총 "}${comFormat((couponCountData > 4 ? String(Number(couponCountData) - 4) : couponCountData)||"0")}개의 가맹점 쿠폰 지급 완료!`}</h1>
                :""}
                <PopupCaptionDotTextBox>
                    <DotText text={"쿠폰팩 발급은 계정 당 1회에 한해 발급 가능하며 회원을 대상으로만 발급됩니다."}/>
                    <DotText text={"사용 완료된 쿠폰은 재사용이 불가합니다."}/>
                    <DotText text={"쿠폰 할인 적용 후, 결제 취소 시 쿠폰은 재발급되지 않습니다."}/>
                    <DotText text={"해당 쿠폰은 예약 혜택으로 제공된 쿠폰으로 현금으로 교환이 불가하며 미사용 시 환불되지 않습니다."}/>
                </PopupCaptionDotTextBox>
                <BtnBox
                    boxType="fixed"
                    addClass=""
                >
                    <BtnItem
                        addClass="gradient"
                        contents={"쿠폰 확인하기"}
                        disabled={false}
                        func={() => {
                            setCouponPopup(null);
                            navigate("/mypage/coupon");
                        }}
                    />
                </BtnBox>
            </CustomPopup>
            <Footer pcOnly={true}/>
            <LoadingBox openType={loadingBoxOpen}/>
        </>
    );
};

export default ReservationDetail;